// Abarnadoc.jsx
import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import abarnadoc from './../../../../assets/images/Doctorsimages/abarnadoc.png' // Ensure this path/image exists
import favicon from "./../../../../assets/images/favicon.ico"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import AutoScrollImageRow from '../..//AdvancedTreatmentsforHome/AutoScrollImageRow'

const Abarnadoc = () => {
  const navigate = useNavigate(); 
  
  useEffect(() => {
    document.title = "Dr. Abarna K | Expert Homeopathy Consultant | Holistic & Chronic Disease Specialist";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Experience personalized healing with Dr. Abarna K (BHMS). Specializing in constitutional homeopathy, chronic disease management, and pediatric care using a deep-rooted holistic approach."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "Dr. Abarna K homeopathy, constitutional homeopathy, chronic disease specialist, pediatric homeopathy, natural healing Coimbatore, Martin Homoeopathy alumni, holistic wellness consultant, non-toxic medical treatment"
      );
    }

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-abarna-k-homeopathy-consultant");
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-abarna-k-homeopathy-consultant");
      document.head.appendChild(canonicalLink);
    }

    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);

  const handleDownloadPdf = () => {
    const container = document.querySelector('.veenadoc');
    container.classList.add('veenadoc-pdf-mode');

    const originalStyles = new Map();
    const allElements = container.querySelectorAll('*');
    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter
      });
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
    });

    const heroSection = container.querySelector('.veenadoc-hero-section');
    if (heroSection) {
      heroSection.style.minHeight = 'auto';
      heroSection.style.padding = '40px 0';
    }

    const images = container.querySelectorAll('img');
    images.forEach(img => { img.style.opacity = '1'; });

    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        dpi: 300,
        useCORS: true,
        allowTaint: true,
        letterRendering: true,
        backgroundColor: '#ffffff',
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight,
      }).then(canvas => {
        container.classList.remove('veenadoc-pdf-mode');
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        });

        if (heroSection) {
          heroSection.style.minHeight = '';
          heroSection.style.padding = '';
        }

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const marginLeft = 10;
        const marginRight = 10;
        const availableWidth = pdfWidth - marginLeft - marginRight;
        const scaleFactor = availableWidth / canvas.width;
        const imgWidth = canvas.width * scaleFactor;
        const imgHeight = canvas.height * scaleFactor;
        const pages = Math.ceil(imgHeight / pdfHeight);

        for (let i = 0; i < pages; i++) {
          if (i > 0) pdf.addPage();
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }
        pdf.save('Dr.Abarna_K_Profile.pdf');
      }).catch(error => {
        console.error('Error generating PDF:', error);
        container.classList.remove('veenadoc-pdf-mode');
      });
    }, 100);
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Abarna K</span>
                  <span className="veenadoc-title-credentials">(BHMS)</span>
                  <span className="veenadoc-title-location">Consultant Homoeopath</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    A pioneer in <strong>Constitutional Homeopathy</strong>, Dr. Abarna K focuses on activating the body’s innate healing intelligence. 
                    By merging traditional wisdom with modern clinical insights, she provides a sanctuary for those seeking lasting recovery from complex ailments.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={abarnadoc} alt="Dr. Abarna K – Consultant Homoeopath & Holistic Healing Expert" className="veenadoc-doctor-image" title='Dr. Abarna K – Consultant Homoeopath & Holistic Healing Expert' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">
              <div className="veenadoc-article-main">
                
                <div className="veenadoc-article-block">
                  <h2>About Dr. Abarna K</h2>
                  <p>
                    Dr. Abarna K (BHMS) is a distinguished practitioner who graduated from the esteemed <strong>Martin Homoeopathy Medical College and Hospital</strong>. 
                    Her academic excellence is matched by her clinical precision, making her a sought-after consultant for patients who prioritize natural, 
                    evidence-based homeopathic interventions.
                  </p>
                  <p>
                    She believes that true health is not merely the absence of disease but a state of vibrant physical and mental harmony. Her methodology 
                    revolves around <strong>Miasmatic prescribing</strong> and individualization, ensuring that the root cause—whether genetic, environmental, 
                    or emotional—is effectively addressed.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS (Martin Homoeopathy Medical College)</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Core Philosophy:</span>
                      <span className="veenadoc-info-value">Constitutional & Holistic Wellness</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Approach:</span>
                      <span className="veenadoc-info-value">Patient-Centric Root-Cause Analysis</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">Expert in Chronic Lifestyle Disorders</span>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-article-block">
                  <h2>The H-Cura Consultation Experience</h2>
                  <p>
                    Consulting with Dr. Abarna is more than a medical appointment; it is a journey of self-discovery. She employs a 
                    <strong> Comprehensive Case-Taking Protocol</strong> that typically lasts 45 to 60 minutes. During this time, she delves into 
                    your medical history, sleep patterns, dietary cravings, and even your response to stress.
                  </p>
                  <p>
                    This deep-dive approach allows her to identify the <strong>"Simillimum"</strong>—the single homeopathic remedy that matches 
                    your unique constitutional type, triggering a profound and permanent healing response.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Specialized Areas of Care</h2>
                  <p>Dr. Abarna offers expert management for a diverse spectrum of health concerns:</p>
                  <ul>
                    <li><strong>Immune System Support:</strong> Strengthening natural defenses against recurring viral infections and seasonal allergies.</li>
                    <li><strong>Metabolic & Endocrine Health:</strong> Natural management of Thyroid imbalances, early-stage Diabetes, and PCOD.</li>
                    <li><strong>Psychosomatic Disorders:</strong> Addressing the physical manifestations of anxiety, depression, and chronic stress.</li>
                    <li><strong>Advanced Dermatological Care:</strong> Treating deep-seated skin issues like vitiligo, lichen planus, and stubborn eczema without steroids.</li>
                    <li><strong>Geriatric Wellness:</strong> Enhancing the quality of life for seniors through pain management and cognitive support.</li>
                  </ul>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Bridging Tradition with Modern Wellness</h2>
                  <p>
                    While rooted in classical Hahnemannian principles, Dr. Abarna integrates modern lifestyle modifications into her treatment plans. 
                    She provides actionable advice on <strong>Nutritional Therapy</strong> and <strong>Stress Management</strong>, recognizing that 
                    remedies work best when supported by a healthy environment.
                  </p>
                  <p>
                    This balanced approach has proven exceptionally successful for lifestyle-induced conditions such as Hypertension, High Cholesterol, 
                    and Chronic Fatigue Syndrome.
                  </p>
                </div>

                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Your Pathway to Sustainable Health</h2>
                  <p>
                    Choosing Dr. Abarna K means opting for a medical professional who listens, understands, and treats you with the dignity you deserve. 
                    Her treatments are non-habit forming, safe for infants and the elderly alike, and designed to minimize the need for heavy chemical intervention.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her Mission:</strong> To democratize holistic health and empower individuals to reclaim their vitality through the 
                    gentle, yet powerful, science of Homeopathy.
                  </p>
                </div>
              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">🌿</div>
                    <blockquote style={{ fontSize: '1.1rem' }}>
                      "Healing is a matter of time, but it is sometimes also a matter of opportunity and the right holistic approach."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Abarna K's Philosophy</p>
                  </div>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Specialized Services</h3>
                  <ul className="veenadoc-services-list">
                    <li>🛡️ Immunity Boosting</li>
                    <li>🧬 Genetic Predisposition Care</li>
                    <li>💆 Stress & Anxiety Relief</li>
                    <li>🩸 Hormonal Balance</li>
                    <li>👶 Gentle Pediatric Care</li>
                    <li>🦴 Joint & Bone Health</li>
                    <li>🧠 Migraine Management</li>
                  </ul>
                </div>

                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Start Your Healing Today</h3>
                  <p>Take the first step toward a side-effect-free recovery with a personalized consultation.</p>
                  <button className="veenadoc-sidebar-btn-primary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>📞</span>
                    <span>Direct Call</span>
                  </button>
                  <button className="veenadoc-sidebar-btn-secondary" onClick={() => navigate('/bookconsultation')}>
                    <span>📅</span>
                    <span>Book Appointment</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download Dr. Abarna's Professional Profile (PDF)
        </button>
      </div>
    </>
  )
}

export default Abarnadoc
